export const LOGIN = "/login";

export const ITINERARY_DETAILS = "/itinerary-details/:itineraryId";
export const QUOTATION_DETAILS = "/quotation-details/:quotationId";
export const PAYMENT_PAGE = "/make-payment/:quotationId";
export const PAYMENT_STATUS = "/payment-status/:encodedData";
export const EMAIL_LOGS = "/email-logs";

export const DASHBOARD = "/";
export const ADD_LEADS = "/add-leads/:stepNumber?/:customerId?";
export const ALL_BOOKINGS = "/all-bookings";
export const TASKS_STATUS = "/tasks-status";
